/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './CardBottom.scss';

// import s from './CardBottom.scss';

function CardBottom(props) {
  const { secdetail = {}, ga4Type } = props;

  const clickHandler = () => {
    sendGaThroughProps({
      data: secdetail.gaData || {},
    });
    if (ga4Type && ga4Type === 'top_stories') {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: `main_line_up`,
        category: `section_click`,
        label: secdetail?.hl,
      });
    }
  };

  return (
    <>
      {secdetail &&
        (secdetail.displayTime || (secdetail.hl && secdetail.wu)) && (
          <div className={`${s.timeStampWrap}`}>
            {secdetail.hl &&
              secdetail.wu && (
                <Link to={secdetail.wu} onClick={() => clickHandler(secdetail)}>
                  {secdetail.hl}
                </Link>
              )}
            {secdetail.hl && secdetail.wu && secdetail.displayTime && ' / '}
            {secdetail.displayTime && secdetail.displayTime}
          </div>
        )}
    </>
  );
}
CardBottom.propTypes = {
  secdetail: PropTypes.shape({
    hl: PropTypes.string,
    wu: PropTypes.string,
    displayTime: PropTypes.string,
    ga4Type: PropTypes.string,
  }),
};
CardBottom.defaultProps = {
  secdetail: {
    hl: '',
    wu: '',
    displayTime: '',
    ga4Type: '',
  },
};

export default React.memo(CardBottom);
